import { splitNameEmail } from '../tools/email-format.js';
import { tenantDetails } from './tenant.js';
/**
 * The tenant's claims mailbox, derived from the canonical display address in
 * `tenantDetails` so a mailbox change cannot leave a stale copy here.
 */
function claimsEmail(tenant) {
    const { address } = tenantDetails[tenant].email;
    return splitNameEmail(address).email ?? address;
}
/**
 * The claim report channel by tenant.
 *
 * The card itself stays neutral — light surface, grey boxes, dark text — and the
 * brand colour appears only on the icons and the call to action. That keeps the
 * copy legible whatever the tenant's colour is, so these are the brands' own
 * values rather than darkened variants of them.
 */
export const claimReportByTenant = {
    domcura: {
        kind: 'form',
        url: 'https://serviceportal.domcura.de/service/schadenmeldung',
        // 'Chili' of the DOMCURA corporate design manual, its call to action colour.
        accent: '#D44021',
    },
    nordvers: {
        kind: 'contact',
        phone: '+49 431 54654-521',
        email: claimsEmail('nordvers'),
        accent: '#005744',
    },
    innoas: {
        kind: 'contact',
        phone: '+49 431 54654-521',
        email: claimsEmail('innoas'),
        accent: '#0080C9',
    },
    asspario: {
        kind: 'contact',
        phone: '0671 88765-0',
        email: claimsEmail('asspario'),
        accent: '#E6007E',
    },
};
